import React, { useContext } from 'react';
import { PriceCalculationContext } from '../../PriceCalculationContext';

function AddedToCartNotice() {
    const { resourcedTexts } = useContext(PriceCalculationContext);

    return (
        <div className="added-to-cart-notice">
            <div className="added-to-cart-notice__icon" />
            <p className="added-to-cart-notice__text">{resourcedTexts.addedToCart}</p>
        </div>
    );
}

export { AddedToCartNotice };
